import { FigmaNodeReference } from "@supernova-studio/model";
import { DTOFigmaNodeOrigin, DTOFigmaNodeRenderFormat } from "./figma-node";
import { z } from "zod";
export const DTOFigmaNodeData = z.object({
    // Id of the node in the Figma file
    figmaNodeId: z.string(),
    // Validity
    isValid: z.boolean(),
    // Asset data
    assetId: z.string(),
    assetUrl: z.string(),
    assetFormat: DTOFigmaNodeRenderFormat,
    // Asset metadata
    assetScale: z.number(),
    assetWidth: z.number().optional(),
    assetHeight: z.number().optional(),
});
export const DTOFigmaNode = FigmaNodeReference.omit({
    data: true,
    origin: true,
}).extend({
    data: DTOFigmaNodeData,
    origin: DTOFigmaNodeOrigin,
});
